module.exports = [{"name":"全部","value":"0,0"},{"name":"200平米以下","value":"0,200"},{"name":"200-300平米","value":"200,300"},{"name":"300-500平米","value":"300,500"},{"name":"500-1000平米","value":"500,1000"},{"name":"1000平米以上","value":"1000,0"}]


//////////////////
// WEBPACK FOOTER
// ./src/pages/index/data/acreage.json
// module id = Ptoj
// module chunks = 38